import React from "react";

function Dashboard() {
  return (
    <div>
      <h2>I'm Dash board page</h2>
    </div>
  );
}

export default Dashboard;
